import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TadManagerConfigView } from "./TadManagerConfigView";
import { TadManagerConfigViewStore } from "../../store/TadManagerConfigViewStore";
import { useStore } from "../../../../hooks";

export const TadManagerConfigViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tadManagerConfig/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TadManagerConfigViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TadManagerConfigView tadManagerConfigViewStore={store} />
      </PageLayout>
    </div>
  );
});
